module.exports = __webpack_public_path__ + "img/gridModeMenu.0efd239e.svg";